import React from 'react';
import './index.scss';

const Toast1 = props => (
  <React.Fragment>
    <div className='model_cover'></div>
    <div className='borderOut'>
      <div className='topClose'>
        <section className='title'>亲密度与等级对照表</section>
        <section className='close' onClick = { () => {
          // eslint-disable-next-line react/prop-types
          props.close()
        }
        }></section>
      </div>
      <div className='main'>
        <section className='main-top'>
          <img className='main-top-img' src= { require('./img/textlogo-1.png') } />
          <div>
            <p>亲密度是提升粉丝等级的衡量标准，通过给主播送礼物可以提高亲密度，提升粉丝等级。<br />粉丝亲密度上限和衰减规则详见底部的“帮助中心”</p>
          </div>
        </section>
        <section className='main-bottom'>
          <img src = { require('./img/toast1-24.png') } />
        </section>
      </div>
    </div>
  </React.Fragment>
)
export default Toast1;
